import React from "react";
import "./button.css";

export default function Button({
  className = "",
  disabled,
  text,
  onClick,
  outlined = false,
  type,
}) {
  return (
    <div>
      <button
        type={type || "button"}
        className={`inline-flex items-center border border-transparent rounded-full active:bg-yellow-500 transition ease-in-out duration-150 
        button-text ${
          outlined ? "border-2 md:border-4 border-violet-600 button-bg" : "button-shadow"
        } ${className}`}
        disabled={disabled}
        onClick={onClick}
      >
        {text}
      </button>
      <div className="bg-yellow-600">
      </div>
    </div>
  );
}
